<ng-container *ngIf="hasItems">
    <div class="row" style="background-color:#e4e9f2">
        <div *ngFor="let item of items" class="col-md-3">
          <nb-card size="small">
            <nb-list>
                <nb-list-item *ngFor="let field of item?.fields" style="font-size:0.8375rem !important">
                    <ubs-item-field [field]="field"></ubs-item-field>
                  </nb-list-item>
            </nb-list>
          </nb-card>
        </div>
    </div>
</ng-container>

